import { Poliester1 } from "./Icons/Poliester";
import { Poliester2 } from "./Icons/Poliester";
import { Poliester3 } from "./Icons/Poliester";
import { Poliester4 } from "./Icons/Poliester";
import { Poliester5 } from "./Icons/Poliester";

export const PreguntasCardsPoliester = () => {
  const cardsPoliester = [
    {
      id: 1,
      text: "Lavar la prenda del revés y junto a colores similares",
      img: <Poliester1 />,
    },
    {
      id: 2,
      text: "Hacerlo con agua fría o hasta 30% de temperatura.",
      img: <Poliester2 />,
    },
    {
      id: 3,
      text: "Usar niveles moderados de jabón y suavizante.",
      img: <Poliester3 />,
    },
    {
      id: 4,
      text: "No usar lejía ni jabones abrasivos.",
      img: <Poliester4 />,
    },
    {
      id: 5,
      text: "Planchar a temperatura media, sin usar vapor y siempre con la prenda del revés, de ser posible con un paño de barrera.",
      img: <Poliester5 />,
    },
  ];

  return (
    <>
      {cardsPoliester.map((item) => (
        <li key={item.id}>
          <picture>{item.img}</picture>
          <p>{item.text}</p>
        </li>
      ))}
    </>
  );
};
